import { UncontrolledTooltip } from 'reactstrap'

const PMBTooltip = ({ target, placement = 'top', text = '', testId = 'pmb-tooltip' }) => (
  <UncontrolledTooltip placement={placement} target={target} data-testid={testId}>
    {text}
  </UncontrolledTooltip>
)

export default PMBTooltip
